import { Box } from '@mui/material';
import { BalancesLayout } from 'components/Layouts/BalancesLayout';
import BagelCodeBalance from 'templates/Balances/BagelCode';
import Me2onBalance from 'templates/Balances/Me2on';
import PipaBalance from 'templates/Balances/Pipa';
import SpaceGoBalance from 'templates/Balances/SpaceGo';
import { GhostBalance } from 'templates/Balances/Ghost';
import { EBalancesTheme } from 'utils/enums';
import { BalancesSectionProps, BalancesThemeMap } from './types';
import { PlaySimpleBalanceLayout } from 'components/Layouts/BalancesLayout/PlaySimpleBalanceLayout';
import React from 'react';
import { GhostVipBadge } from 'templates/Balances/Ghost/GhostVipBadge/GhostVipBadge';

export const BalancesSection: React.FC<BalancesSectionProps> = ({
  balances,
  balanceTheme,
  balanceQuantityFormat,
  playerLevelImg,
}) => {
  const balancesThemeMap: BalancesThemeMap = {
    [EBalancesTheme.BAGELCODE]: BagelCodeBalance,
    [EBalancesTheme.SPACEGO]: SpaceGoBalance,
    [EBalancesTheme.ME2ON]: Me2onBalance,
    [EBalancesTheme.PIPA]: PipaBalance,
    [EBalancesTheme.GHOST]: GhostBalance,
  };
  const BalanceDesign = balancesThemeMap[balanceTheme];

  return (
    <Box mt={balanceTheme === EBalancesTheme.SPACEGO ? '-8px' : '0'}>
      {balanceTheme === EBalancesTheme.PLAY_SIMPLE ? (
        <PlaySimpleBalanceLayout
          balances={balances}
          balanceTheme={balanceTheme}
          balanceQuantityFormat={balanceQuantityFormat}
        />
      ) : (
        <BalancesLayout balanceTheme={balanceTheme}>
          {balanceTheme === EBalancesTheme.GHOST && playerLevelImg && (
            <GhostVipBadge playerLevelImg={playerLevelImg} />
          )}
          {balances.map((balance, index) => {
            return (
              <BalanceDesign
                key={`${balanceTheme}${index}`}
                balance={balance}
                balanceQuantityFormat={balanceQuantityFormat}
              />
            );
          })}
        </BalancesLayout>
      )}
    </Box>
  );
};
